export default "__VITE_ASSET__BmdRCjHI__"